import { CustomerService } from "./CustomerService";
import { CustomerSocial } from "./CustomerSocial";
import { Contract } from "./Contract";
import { Country } from "../Country";
import { ExcludedContractStep } from './ExcludedContractStep';

export class Customer {
    public id: string;
    public numericId: number;
    public idCountry: string;
    public idDistributor: string;
    public workshopName: string;
    public locationAddress: string;
    public city: string;
    public postCode: string;
    public district: string;
    public customerId: string;
    public ownersName: string;
    public email: string;
    public website: string;
    public vatNumber: string;
    public telephone: string;
    public mobile: string;
    public idWorkshopArea: string;
    public idTrafficFlow: string;
    public workshopVisibility: string;
    public exFCAWorkshop: boolean;
    public mqTotal: number;
    public signage: boolean;
    public signageNote: string;
    public signHighTrafficStreet: string;
    public entrancesNumber: number;
    public workersNumber: number;
    public waitingRoom: boolean;
    public waitingRoomNote: string;
    public idWorkshopAppearance: string;
    public warehouse: boolean;
    public warehouseNote: string;
    public carBrigdgeLifterNumber: number;
    public increasingBridgeLifter: boolean;
    public consumerReview: string;
    public advertInvestments: boolean;
    public digitalPlatform: boolean;
    public petronasDigitalPlatform: boolean;
    public trainingParticipation: boolean;
    public idTrainingType: string;
    public trainingTypeNote: string;
    public trainingProvidedBy: string;
    public idTrainingPerYear: string;
    public assessmentScore: number;
    public currentVersion: [];
    public imported: boolean;
    public idDistrict: string;
    public lastContractSalesman: string;
    public lastContractTypeOfProposal: string;
    public lastContractYear: number;
    public lastContractId: string;
    public welcomeKitSize: string;
    public welcomeKitNotes: string;
    public latitude:Number;
    public longitude:Number;
    public excludedContractSteps: ExcludedContractStep[];

    public socials: Array<CustomerSocial>;
    public services: Array<CustomerService>;
    public contracts: Array<Contract>;
    public country: Country;
}
